var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24937 9.99945C1.24937 10.1652 1.31522 10.3242 1.43243 10.4414C1.54964 10.5586 1.70861 10.6244 1.87437 10.6244H16.6156L12.6819 14.5569C12.5645 14.6743 12.4986 14.8335 12.4986 14.9994C12.4986 15.1654 12.5645 15.3246 12.6819 15.4419C12.7992 15.5593 12.9584 15.6252 13.1244 15.6252C13.2903 15.6252 13.4495 15.5593 13.5669 15.4419L18.5669 10.4419C18.6251 10.3839 18.6713 10.3149 18.7028 10.239C18.7343 10.1631 18.7505 10.0817 18.7505 9.99945C18.7505 9.91724 18.7343 9.83584 18.7028 9.7599C18.6713 9.68397 18.6251 9.615 18.5669 9.55695L13.5669 4.55695C13.5088 4.49884 13.4398 4.45274 13.3639 4.42129C13.2879 4.38984 13.2066 4.37366 13.1244 4.37366C12.9584 4.37366 12.7992 4.43959 12.6819 4.55695C12.5645 4.6743 12.4986 4.83348 12.4986 4.99945C12.4986 5.16542 12.5645 5.32459 12.6819 5.44195L16.6156 9.37445H1.87437C1.70861 9.37445 1.54964 9.4403 1.43243 9.55751C1.31522 9.67472 1.24937 9.83369 1.24937 9.99945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.921afba9ebd37f4a5a72d6dd69b3a17b.svg";
export { ForwardRef as ReactComponent };